<template>
  <v-card-title class="py-0 px-2">
    <v-list two-line class="py-0">
      <v-list-item class="my-0">
        <v-list-item-avatar
          v-if="!$vuetify.breakpoint.smAndUp"
          class="my-0"
          @click="$emit('open-drawer')"
        >
          <v-icon> mdi-menu </v-icon>
        </v-list-item-avatar>

        <v-list-item-content class="py-0">
          <v-list-item-title>
            <span class="font-weight-medium secondary-font">
              {{ header.title }}
            </span>
          </v-list-item-title>

          <v-list-item-subtitle>
            <span>
              {{ header.subtitle }}
            </span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-spacer />

    <template v-if="conversation">
      <conversation-actions
        :conversation="conversation"
        :loading="loading"
        :forms="forms"
        :form="form"
        :is-participant="isParticipant"
        @join="$emit('join')"
        @refresh="$emit('refresh')"
        @update:form="$emit('update:form', $event)"
      />

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="$emit('toggle-info')">
            <v-icon> mdi-information-outline </v-icon>
          </v-btn>
        </template>

        <span>
          {{ $t("chat.conversation.infos.subtitle") }}
        </span>
      </v-tooltip>
    </template>
  </v-card-title>
</template>

<script>
import ConversationActions from "./conversation-actions.vue";

export default {
  name: "ConversationHeader",

  components: {
    ConversationActions,
  },

  props: {
    conversation: {
      type: Object,
      default: null,
    },

    loading: {
      type: Object,
      default: () => ({}),
    },

    forms: {
      type: Array,
      default: () => [],
    },

    form: {
      type: Object,
      required: true,
    },

    isParticipant: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    header() {
      if (!this.conversation) {
        return {
          title: this.$t("chat.infos.title"),
          subtitle: this.$t("chat.infos.subtitle"),
        };
      }

      return {
        title: this.$t("chat.infos.title1", {
          contactId: this.conversation.sourceId,
          channel: this.conversation.channel.type,
        }),

        subtitle: this.$t("chat.infos.subtitle1", {
          service: this.conversation.channel.service.name,
        }),
      };
    },
  },
};
</script>
